import { useFeatureFlagSplit } from '@verantos-dev/app-state-base';
import { getProjectPath, getProjectsBasePath } from '@verantos-dev/core-constants';
import type { PageHeaderBreadcrumb } from '@verantos-dev/shared-components';

import { useAdRouteParams } from './useAdRouteParams';

/**
 * Breadcrumbs for the analytical-dataset detail page (OR-6123 F8):
 * `Project home / <dataset>`.
 *
 * Gated on `research_assistant_gen_3` — this page is reachable with the flag
 * OFF (the legacy `<Outlet/>` path), where there was never a project-header
 * breadcrumb above it; adding one there would regress the legacy surface. When
 * the flag is OFF this returns `undefined` so the page passes no `breadcrumbs`
 * to its `PageHeader` (unchanged legacy rendering).
 *
 * Co-located here rather than in feature-project-page — feature-analytical-
 * datasets can't depend on it without inverting the layering.
 *
 * TODO: cleanup with research_assistant_gen_3 ff
 */
export const useAnalyticalDatasetBreadcrumbs = (
  datasetName: string
): PageHeaderBreadcrumb[] | undefined => {
  const isGen3Enabled = Boolean(useFeatureFlagSplit('research_assistant_gen_3', false));
  const { projectId } = useAdRouteParams();

  if (!isGen3Enabled) return undefined;

  return [
    {
      label: 'Project home',
      href: projectId ? getProjectPath(projectId) : getProjectsBasePath(),
    },
    { label: datasetName },
  ];
};
